import React, { useEffect } from 'react';

import BurgerIcon from '@lt/components/icons-react/rebrand/Burger';
import type { CLIENT } from '@lt/api/dist/types/client';
import { removeURLParam } from 'src/components/AuthNew/utils';
import { handleTbankWebviewAuth } from 'src/components/AuthNew/hooks/handleTbankWebviewAuth';
import { useSearchParams } from 'src/components/AuthNew/hooks/useResetPasswordToken';
import { MOBILE_BURGER_MENU_TEST_ID } from '../constants';
import styles from './mobileMenu.module.css';

type Props = {
  openSidebar: () => void;
  logIn: (client: CLIENT) => void;
};

const MobileMenu = (props: Props) => {
  const { openSidebar, logIn } = props;

  const { code } = useSearchParams('code');
  const { state } = useSearchParams('state');
  const { session_state } = useSearchParams('session_state');

  useEffect(() => {
    const isTBankAuth = code && state && session_state;

    if (isTBankAuth) {
      handleTbankWebviewAuth(
        code,
        state,
        session_state,
        (client) => {
          logIn(client);
        },
        (error) => {
          // eslint-disable-next-line no-console
          console.error('TBank auth error:', error);
        },
      );
    }
    removeURLParam('code');
    removeURLParam('state');
    removeURLParam('session_state');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, state, session_state]);

  return (
    <BurgerIcon
      className={styles.burger}
      onClick={openSidebar}
      data-testid={MOBILE_BURGER_MENU_TEST_ID}
    />
  );
};

export default MobileMenu;
